export default __webpack_public_path__ + "static/card-1-3d11091f6b4991a8b60e50a5b9d60cd9.png";